import { render, staticRenderFns } from "./productionorder.vue?vue&type=template&id=4466880d&scoped=true&"
import script from "./productionorder.vue?vue&type=script&lang=js&"
export * from "./productionorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466880d",
  null
  
)

export default component.exports